<script>
import UserDetailStatisticTile from '@/components/user/tiles/UserDetailStatisticTile.vue';
import BaseTabs2 from '@/components/BaseTabs2.vue';
import BaseButton from '@/components/BaseButton.vue';
import UserDetailContactTile from '@/components/user/tiles/UserDetailContactTile.vue';

// есть вопросы по вычислению изменения числа контактов за месяц
// число удаленных контактов вычислить представляется сложным по той же причине

export default {
  name: 'UserDetailContactsTab',
  components: {
    UserDetailStatisticTile,
    BaseTabs2,
    BaseButton,
    UserDetailContactTile,
  },
  props: {
    contacts: Array,
    user: Object,
  },
  data() {
    return {
      tab: 'accepted',
    };
  },
  computed: {
    contactsStatistic() {
      return {
        accepted:  { label: 'Всего контактов',    icon: 'notebook',       value: this.contactsAccepted.length,      title: '0 за месяц' }, // eslint-disable-line
        incoming:  { label: 'Входящие',           icon: 'bell3',          value: this.contactsIncoming.length,      title: 'Контактов'   }, // eslint-disable-line
        outComing: { label: 'Исходящие',          icon: 'new-contact',    value: this.contactsOutComing.length,     title: 'Контактов'  }, // eslint-disable-line
        // deleted:   { label: 'Удалённые',          icon: 'close-green',    value: 0,                                 title: '0 за месяц' }, // eslint-disable-line
      };
    },

    tabs() {
      return [
        { name: 'accepted',     label: 'Мои контакты'                                           }, // eslint-disable-line
        { name: 'incoming',     label: 'Входящие заявки', count: this.contactsIncoming.length   }, // eslint-disable-line
        { name: 'outComing',    label: 'Исходящие заявки', count: this.contactsOutComing.length }, // eslint-disable-line
      ];
    },

    userAcceptor() {
      return (this.contacts ?? []).filter(contact => contact.acceptor['@id'] === this.user['@id']);
    },

    userAuthor() {
      return (this.contacts ?? []).filter(contact => contact.author['@id'] === this.user['@id']);
    },

    contactsAccepted() {
      const acceptedIncoming = this.userAcceptor.filter(contact => !contact.isRequest).map(contact => ({ ...contact.author, 'contact@id': contact['@id'], contactId: contact.id }));
      const acceptedOutComing = this.userAuthor.filter(contact => !contact.isRequest).map(contact => ({ ...contact.acceptor, 'contact@id': contact['@id'], contactId: contact.id }));

      return [...acceptedIncoming, ...acceptedOutComing];
    },

    contactsIncoming() {
      return this.userAcceptor.filter(contact => contact.isRequest).map(contact => ({ ...contact.author, 'contact@id': contact['@id'], contactId: contact.id }));
    },

    contactsOutComing() {
      return this.userAuthor.filter(contact => contact.isRequest).map(contact => ({ ...contact.acceptor, 'contact@id': contact['@id'], contactId: contact.id }));
    },

    contactsSorted() {
      return {
        accepted: this.contactsAccepted,
        incoming: this.contactsIncoming,
        outComing: this.contactsOutComing,
      };
    },

    selectedContacts() {
      return this.contactsSorted[this.tab];
    },
  },
};
</script>

<template lang="pug">
.b-user-detail-contacts-tab
  UserDetailStatisticTile._statistic(:statistic="contactsStatistic" :statisticTileWidth="295" label="Контакты" isBorderShown)
  ._options
    BaseTabs2(:items="tabs" :value="tab" @input="tab = $event")
    BaseButton(dark round lg)
      Icon(name="icon-btn-green")
      | Добавить
  ._contacts
    UserDetailContactTile(v-for="contact in selectedContacts" :key="contact.id" :contact="contact" @deleteContact="$emit('deleteContact', $event)" white shadow isMenuAvailable)
</template>

<style scoped lang="scss">
.user-detail-contacts-tab {
  display: flex;
  flex-direction: column;
  gap: 42px;

  &__options {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__contacts {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }
}
</style>
